import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
import './TermsPage.css';

export function TermsPage() {
  return (
    <div className="terms-page">
      <SEO
        title="Terms of Service & Privacy Policy"
        description="Hygh Vybe terms of service, privacy policy, and legal information for our THC beverage discovery platform."
        canonical="/terms"
        noindex
      />
      <header className="terms-page__hero">
        <h1>Terms of Service & Privacy Policy</h1>
        <p className="terms-page__subtitle">
          Last updated: June 2026
        </p>
      </header>

      {/* Terms of Service */}
      <section className="terms-page__section">
        <h2>Terms of Service</h2>

        <h3>What Hygh Vybe Is</h3>
        <p>
          Hygh Vybe is an informational and review platform for THC beverages. We aggregate
          product data from manufacturers, display reviews from our community, and link you to
          the brands' own websites if you're interested in purchasing.
        </p>

        <h3>We Don't Sell Products</h3>
        <p>
          Hygh Vybe does not sell THC beverages or any other products directly. All product
          information — descriptions, images, pricing — is sourced from third-party
          manufacturers and may not always be current or accurate. When you click a link to buy
          something, you're leaving our site and dealing directly with that brand or retailer.
        </p>

        <h3>Reviews & Ratings</h3>
        <p>
          User-submitted reviews and ratings represent individual opinions. They are not
          endorsements by Hygh Vybe. We don't verify claims made in reviews, and everyone's
          experience with THC products is different.
        </p>

        <h3>Age Requirement</h3>
        <p>
          You must be 21 years of age or older to use this platform. By using Hygh Vybe, you
          confirm that you meet this requirement.
        </p>

        <h3>Content Guidelines</h3>
        <p>
          We reserve the right to remove reviews, ratings, or other user-generated content that
          violates our community guidelines — including spam, hate speech, misleading claims, or
          content that promotes unsafe consumption.
        </p>

        <h3>External Links</h3>
        <p>
          Links to manufacturer websites and other external sites are provided for your
          convenience. Hygh Vybe is not responsible for the content, privacy practices, or
          products available on third-party websites. Any purchases you make through those links
          are between you and that retailer.
        </p>

        <h3>Affiliate Disclosure</h3>
        <p>
          For some brands, we are an affiliate and provide affiliate links in which we may earn a
          commission.
        </p>
      </section>

      {/* Privacy Policy */}
      <section className="terms-page__section">
        <h2>Privacy Policy</h2>

        <h3>What We Collect</h3>
        <ul className="terms-page__list">
          <li>
            <strong>Account info:</strong> email address and display name (if you create an
            account)
          </li>
          <li>
            <strong>Usage data:</strong> anonymous analytics to help us improve the platform
          </li>
        </ul>

        <h3>What We Don't Do</h3>
        <ul className="terms-page__list">
          <li>We do NOT sell your personal data to third parties</li>
          <li>We do NOT track or store your purchase history</li>
        </ul>

        <h3>Public Information</h3>
        <p>
          If you leave a review or rating, it will be displayed publicly alongside your display
          name. Keep this in mind when choosing your display name and writing reviews.
        </p>

        <h3>Cookies</h3>
        <p>
          We use cookies only for authentication — keeping you logged in between sessions.
          That's it. No advertising cookies, no third-party trackers.
        </p>

        <h3>Analytics</h3>
        <p>
          We may use anonymous analytics (page views, general usage patterns) to understand how
          people use the platform and make it better. This data is aggregated and cannot be used
          to identify you.
        </p>

        <h3>Deleting Your Data</h3>
        <p>
          You can request deletion of your account and all associated data by contacting us. Once
          deleted, your reviews will be removed and your personal information will be permanently
          erased from our systems.
        </p>

        <h3>A Note on THC Legality</h3>
        <p>
          Hemp-derived THC beverages are legal in many states under the 2018 Farm Bill. Hygh Vybe
          does not track or store purchase history, and we don't share your browsing data with
          anyone. Always verify THC legality in your state before purchasing from manufacturer
          sites.
        </p>
      </section>

      {/* Footer disclaimer */}
      <section className="terms-page__disclaimer">
        <p>
          Hygh Vybe is not a retailer. We provide product information and link to manufacturer
          websites. Always verify THC legality in your state before purchasing.
        </p>
      </section>

      <section className="terms-page__section terms-page__cta-section">
        <p>Questions about these policies? Reach out to us anytime.</p>
        <Link to="/" className="terms-page__cta">
          Back to Home
        </Link>
      </section>
    </div>
  );
}
